import { render, staticRenderFns } from "./BIBadgeCompetitorMenu.vue?vue&type=template&id=066a32b3"
import script from "./BIBadgeCompetitorMenu.vue?vue&type=script&lang=js"
export * from "./BIBadgeCompetitorMenu.vue?vue&type=script&lang=js"
import style0 from "./BIBadgeCompetitorMenu.vue?vue&type=style&index=0&id=066a32b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports